import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { DomesManagement } from '../modal';

export default function reducer(state: DomesManagement = new DomesManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.DOMES_MGMT_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.DOMES_MGMT_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.DOMES_MGMT_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
